import { useNavigate } from "react-router-dom";
import {
  HOME,
  HOME_CHARACTERS,
  HOME_OBJECTS,
  HOME_STYLES,
  WORKSPACES,
} from "../../../routes.ts";
import { CHARACTER_MODEL_TYPE, STYLE_MODEL_TYPE } from "../../constants.ts";
import { useModels } from "../../hooks/useModels.ts";
import { useWorkspaceUuid } from "../../hooks/useWorkspaceUuid.ts";

export const useRedirectToHomepageModels = (selectedModelUuid?: string) => {
  const navigate = useNavigate();
  const workspaceUuid = useWorkspaceUuid();
  const { models } = useModels();
  const selectedModel = models.find(
    (model) => model.uuid === selectedModelUuid,
  );
  return () =>
    navigate(
      `${WORKSPACES}/${workspaceUuid}/${HOME}/${
        selectedModel === undefined
          ? ""
          : selectedModel.type === STYLE_MODEL_TYPE
          ? HOME_STYLES
          : selectedModel.type === CHARACTER_MODEL_TYPE
          ? HOME_CHARACTERS
          : HOME_OBJECTS
      }`,
    );
};
